import React, { Component, Fragment } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Helmet from 'react-helmet'

import ScrollToTop from './components/ScrollToTop'
import Meta from './components/Meta'
import ServiceWorkerNotifications from './components/ServiceWorkerNotifications'
import data from './data.json'
import { slugify } from './util/url'
import { documentHasTerm, getCollectionTerms } from './util/collection'

import Footer from './components/molecules/Footer/Footer'

import HomePage from './pages/HomePage/HomePage'
import CalendarPage from './pages/Calendar/CalendarPage'
import AccountabilityPage from './pages/Accountability/Accountability'
import ApplicationPage from './pages/Application/ApplicationPage'
import ApplicationPaymentPage from './pages/Application/ApplicationPaymentPage'
import ApplicationCompletePage from './pages/Application/ApplicationCompletePage'
import BookATourPage from './pages/BookATour/BookATourPage'
import BookATourConfirmationPage from './pages/BookATour/BookATourConfirmationPage'
import MessagePage from './pages/Message/MessagePage'
import WhyMontessoriPage from './pages/WhyMontessori/WhyMontessoriPage'
import CareersPage from './pages/Careers/CareersPage'
import CurriculumPage from './pages/Curriculum/CurriculumPage'
import ProgramsPage from './pages/Programs/ProgramsPage'
import FourOhFour from './pages/404/404'
import LandingPage from './pages/LandingPage/LandingPage'

const RouteWithMeta = ({ component: Component, ...props }) => (
  <Route
    {...props}
    render={routeProps => (
      <Fragment>
        <Meta {...props} />
        <Component {...routeProps} {...props} />
      </Fragment>
    )}
  />
)

class App extends Component {
  state = {
    data
  }

  getDocument = (collection, name) =>
    this.state.data[collection] &&
    this.state.data[collection].filter(page => page.name === name)[0]

  getDocuments = collection => this.state.data[collection] || []
  
  renderLandingPageRoutes = () => {
    var self = this;
    const landingPages = this.getDocuments('landing-pages');

    const siteNavigations = this.getDocuments('site-navigations');
    const navigationItems = this.getDocument('site-navigations', 'default').navigationItems;
    
    console.log(`>>>>>> Landing Pages`);
    console.log(landingPages);
    console.log(`>>>>>> Site Navigations`);
    console.log(siteNavigations);
    console.log(`>>>>>> Site Navigations > Default`);
    console.log(navigationItems);

    const landingPageRoutes = landingPages.map((landingPage, index) => {
      const landingPageComponent = () => (
        <LandingPage
          config={{ hasHeader: true }}
          content={{
            header: {
              config: {
                showLogo: true,
              },
              content: {
                navigationItems: self.getDocument('site-navigations', landingPage.pageNavigation.toLowerCase()).navigationItems,
              },
            },
            page: landingPage
          }}
        />
      );

      return (
        <Route
          key={`landing-page-route-${index}`}
          path={landingPage.pageUrl}
          exact
          render={landingPageComponent}
        />
      );
    });

    return landingPageRoutes;
  }

  render() {
    const globalSettings = this.getDocument('settings', 'global')
    const {
      siteTitle,
      siteUrl,
      siteDescription,
      socialMediaCard,
      headerScripts
    } = globalSettings


    const currentYear = (new Date()).getFullYear();
    const navigationItems = this.getDocument('site-navigations', 'default').navigationItems;

    return (
      <Router>
        <div className='React-Wrap'>
          <ScrollToTop />
          <ServiceWorkerNotifications reloadOnUpdate />
          <Helmet
            defaultTitle={siteTitle}
            titleTemplate={`${siteTitle} | %s`}
          />
          <Meta
            headerScripts={headerScripts}
            absoluteImageUrl={
              socialMediaCard &&
              socialMediaCard.image &&
              siteUrl + socialMediaCard.image
            }
            twitterCreatorAccount={
              socialMediaCard && socialMediaCard.twitterCreatorAccount
            }
            twitterSiteAccount={
              socialMediaCard && socialMediaCard.twitterSiteAccount
            }
          />

          <Switch>
            <Route
              path='/'
              exact
              render={props => (
                <HomePage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'home-page')
                  }
                  }
                  {...props}
                />
              )}
            />

            <Route
              path='/school-calendar'
              exact
              render={props => (
                <CalendarPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'calendar-page'),
                    title: `School Calendar`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/our-programs'
              exact
              render={props => (
                <ProgramsPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'programs-page'),
                    title: `Our Programs`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/accountability'
              exact
              render={props => (
                <AccountabilityPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'accountability-page'),
                    title: `Accountability`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/application'
              exact
              render={props => (
                <ApplicationPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'application-page'),
                    title: `Application`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/application-payment'
              exact
              render={props => (
                <ApplicationPaymentPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'application-payment-page'),
                    title: `Application - Payment`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/application-complete'
              exact
              render={props => (
                <ApplicationCompletePage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'application-complete-page'),
                    title: `Application - Complete`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/tours'
              exact
              render={props => (
                <BookATourPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'book-a-tour-page'),
                    title: `Book A Tour`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/tour-confirmation'
              exact
              render={props => (
                <BookATourConfirmationPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'book-a-tour-confirmation-page'),
                    title: `Book A Tour - Confirmation`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/application-payment'
              exact
              render={props => (
                <ApplicationPaymentPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'application-payment-page'),
                    title: `Application Payment`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/message-from-the-director'
              exact
              render={props => (
                <MessagePage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'message-page'),
                    title: `Message from the Director`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/why-montessori'
              exact
              render={props => (
                <WhyMontessoriPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'why-montessori-page'),
                    title: `Why Montessori?`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/curriculum'
              exact
              render={props => (
                <CurriculumPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'curriculum-page'),
                    title: `Curriculum`
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path='/careers'
              exact
              render={props => (
                <CareersPage
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    page: this.getDocument('pages', 'careers-page'),
                    title: `Careers`
                  }}
                  {...props}
                />
              )}
            />

            {this.renderLandingPageRoutes()}

            <Route
              render={props => (
                <FourOhFour
                  config={{ hasHeader: true }}
                  content={{
                    header: {
                      config: {
                        showLogo: true,
                      },
                      content: {
                        navigationItems,
                      },
                    },
                    title: `404`
                  }}
                  {...props}
                  siteUrl={siteUrl}
                />
              )}
            />
          </Switch>

          <Footer currentYear={currentYear} />
        </div>
      </Router>
    )
  }
}

export default App
